import { onMount, type Component } from "solid-js";
import gsap from "gsap";

export const Callout: Component<
  Callout & { index?: () => number; class?: string }
> = (props) => {
  let calloutRef: HTMLDivElement;

  onMount(() => {
    if (props.index) {
      gsap.fromTo(
        calloutRef,
        {
          opacity: 0,
          y: "30px",
        },
        {
          opacity: 1,
          y: 0,
          scrollTrigger: { trigger: calloutRef, start: "top bottom" },
          delay: props.index() * 0.2,
          duration: 0.75,
        }
      );
    }
  });

  return (
    <div
      ref={(ref) => (calloutRef = ref)}
      class={`flex flex-col items-center gap-3 text-center p-3  ${props.class ?? ""}`}
    >
      <div >
        <img src={props.image} alt="" width={props.imageWidth ?? 90} />
      </div>
      <h4 class="text-base font-bold">{props.heading}</h4>
      <p class=" text-balance text-sm font-light">{props.copy}</p>
    </div>
  );
};
